module.exports = __webpack_public_path__ + "fonts/Nunito-Italic-Variable.d5806d3.woff2";